import React, { useImperativeHandle, useRef, useState } from 'react';
import { connect } from 'react-redux';

import CheckCardModal from '@/components/Cards/check';
import { DoorLockCode } from '@/pages/device/card/interface';
import DeleteDoorCardModal from '@/components/Cards/components/DeleteDoorCardModal';

interface IProps {
  innerRef;
  enabledVendor: any;
}

const Index = (props: IProps) => {
  const [roomIds, setIdList] = useState(null);
  const [roomNos, setRoomNos] = useState(null);
  const handler = useRef(() => {});

  const [deleteModalVisibile, setDeleteModalVisibile] = useState(false);
  const deleteRef = useRef<any>();

  useImperativeHandle(
    props.innerRef,
    () => ({
      showModal: (ids, nos, callback) => {
        handler.current = callback;
        setIdList(ids);
        setRoomNos(nos);

        if (props?.enabledVendor?.lockCode === DoorLockCode.BE_LINE) {
          deleteRef.current?.openModal();
        } else {
          setDeleteModalVisibile(true);
        }
      },
    }),
    [],
  );
  if (!roomIds) return null;

  const handleCallback = () => {
    const callback = handler.current;
    setIdList(null);
    setRoomNos(null);
    if (typeof callback === 'function') {
      callback();
    }
  };

  return (
    <>
      {props?.enabledVendor?.lockCode === DoorLockCode.BE_LINE ? (
        <DeleteDoorCardModal
          innerRef={deleteRef}
          enabledVendor={props.enabledVendor}
          roomIds={roomIds}
          roomNo={roomNos?.[0]}
          checkCallBack={() => {
            deleteRef.current.closeModal();
            handleCallback();
          }}
        />
      ) : (
        <CheckCardModal
          checkModalVisibile={deleteModalVisibile}
          roomIds={roomIds}
          checkCallBack={handleCallback}
        />
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  const { enabledVendor } = state.card;
  return { enabledVendor };
};

export default connect(mapStateToProps, {})(Index);
